<style>
.animate-click {
  /* Agrega aquí tus estilos de animación */
  animation: buttonClickAnimation 0.3s;
}

@keyframes buttonClickAnimation {

  /* Define aquí los estilos de animación para el clic del botón */
  0% {
    /* Estilos iniciales */
    transform: scale(1);
  }

  50% {
    /* Estilos intermedios */
    transform: scale(0.5);
  }

  100% {
    /* Estilos finales */
    transform: scale(1);
  }
}
</style>
<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Información de Productos</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <form class="form-inline justify-content-sm-end" @submit="filterDataSubmit">
                <input class="form-control form-control-sm rounded bright col-2" placeholder="Producto"
                  v-model="filter.producto" type="text" />
                <input class="form-control form-control-sm rounded bright col-2" placeholder="Search"
                  v-model="searchtext" type="text" />
                <select v-model="filter_activo" class="form-control form-control-sm rounded bright"
                  @change="filterData">
                  <option value>Todos</option>
                  <option value="false">Inactivos</option>
                  <option value="true">Activos</option>
                </select>
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData()">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de Resultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>SKU</th>
                <th>Nombre</th>
                <th class="text-center">Venta</th>
                <th class="text-center">Compra</th>
                <th class="text-center">Estatus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id" @click="refreshPrecios(current.sku)">
                <td>{{ current.sku }}</td>
                <td>{{ current.nombre }}</td>
                <td class="text-center">
                  <div v-if="current.permitir_venta" class="status-pill green" data-toggle="tooltip"></div>
                  <div v-if="!current.permitir_venta" class="status-pill red" data-toggle="tooltip"></div>
                </td>
                <td class="text-center">
                  <div v-if="current.permitir_compra" class="status-pill green" data-toggle="tooltip"></div>
                  <div v-if="!current.permitir_compra" class="status-pill red" data-toggle="tooltip"></div>
                </td>
                <td class="text-center">
                  <div v-if="current.activo" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
                  <div v-if="!current.activo" class="status-pill red" data-title="Inactivo" data-toggle="tooltip"></div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>

    <div aria-hidden="true" class="onboarding-modal modal fade animated" id="onboardingSlideModal" role="dialog"
      tabindex="-1">
      <div style="padding-right:5px" class="modal-dialog" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" @click="hideModal" type="button">
            <span class="close-label">Cerrar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-slider-w">
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <div class="text-center col-12">
                  <span style="font-size: 17px; font-weight: bold" class="todo-content-header text-success">
                    <span><i class="fas fa-caret-right"></i>&nbsp;{{ current.sku }}
                      <br>
                      {{ current.nombre }}</span>
                  </span>
                  <button title="Copiar nombre del producto" class="btn btn-link" @click="copyContent(current)"
                    style="font-size: 20px; color: #636360" onmouseover="this.style.color='#424240'"
                    onmouseout="this.style.color='#636360'" :class="{ 'animate-click': isClicked }"
                    @animationend="resetAnimation">
                    <i class="far fa-copy"></i>
                  </button>
                </div>
                <hr />
                <div class="row">
                  <div class="col-12">
                    <table>
                      <tr>
                        <td class="text-right" style="padding: 0px">Activo</td>
                        <td>
                          <span style="font-size: 20px" :class="{
                            'fas fa-check-circle text-success': current.activo == true,
                            'far fa-circle text': current.activo == false,
                          }"></span>
                        </td>
                        <td style="padding: 0px" class="text-right">Consumible</td>
                        <td style="font-size: 20px" :class="{
                          'fas fa-check-circle text-success':
                            current.consumible == true,
                          'far fa-circle text': current.consumible == false,
                        }"></td>
                      </tr>
                      <tr>
                        <td class="text-right" style="padding: 0px">Peso</td>
                        <td style="font-size: 20px" :class="{
                          'fas fa-check-circle text-success': current.peso == true,
                          'far fa-circle text': current.peso == false,
                        }"></td>
                        <td class="text-right" style="padding: 0px">Activo fijo</td>
                        <td style="font-size: 20px" :class="{
                          'fas fa-check-circle text-success':
                            current.es_activo_fijo == true,
                          'far fa-circle text': current.es_activo_fijo == false,
                        }"></td>
                      </tr>
                      <tr>
                        <td style="padding: 0px" class="text-right">Tipo Servicio</td>
                        <td style="padding: 0px; font-size: 20px" :class="{
                          'fas fa-check-circle text-success':
                            current.es_servicio == true,
                          'far fa-circle text': current.es_servicio == false,
                        }"></td>
                        <td class="text-right" style="padding: 0px">Multiplicador</td>
                        <td @click="updateMultiplicador(current)" style="font-size: 20px" :class="{
                          'fas fa-check-circle text-success':
                            current.permitir_multiplicador == true,
                          'far fa-circle text':
                            current.permitir_multiplicador == false,
                        }"></td>
                      </tr>
                    </table>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-8" style="text-align: left;">
                    <label class="text-success" style="font-weight: bold;">Proveedores</label>
                    <div v-for="det in dataproveedores" v-bind:key="det.id" style="font-size: 10px; font-weight: bold"
                      class="text-left">
                      <span>{{ det.proveedor_obj.codigo }} -
                        {{ det.proveedor_obj.nombre.substring(0, 20) }}
                        <span v-if="det.proveedor_obj.nombre.length > 21">...</span></span>
                    </div>
                  </div>
                  <div class="col-4" style="text-align: left;">
                    <label class="text-success" style="font-weight: bold">Barras</label>
                    <div class="text-left" style="font-size: 11px;" v-for="detalle in currentBarras"
                      v-bind:key="detalle.id">
                      {{ detalle.barra }}
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-8" style="text-align: left;">
                    <div>
                      <label class="text-success text-left" style="font-weight: bold;">Categoría</label>
                      <br>
                      <span class="text-left" style="font-weight: bold; font-size: 10px;">
                        {{ current.categoria }}
                      </span>
                    </div>
                  </div>
                  <div class="col-4" style="text-align: left;">
                    <label class="text-success text-left" style="font-weight: bold;">Sub Cat.</label>
                    <br>
                    <span class="text-left" style="font-weight: bold; font-size: 10px;">
                      {{ current.sub_categoria }}
                    </span>
                  </div>
                </div>
                <hr>
                <div class="col-12">
                  <button @click="imprimir_hablador()" class="btn btn-link btn-md" style="color: black;">
                    <i class="fas fa-print"></i>
                    <br />
                    Hablador
                  </button>
                  <button @click="imprimir_barra()" class="btn btn-link btn-md" style="color: black;">
                    <i class="fas fa-barcode"></i>
                    <br />
                    Barras
                  </button>
                  <button @click="verKardex()" class="btn btn-link btn-md" style="color: black;">
                    <i class="fas fa-list"></i>
                    <br />
                    Kardex
                  </button>
                </div>
              </div>
            </div>
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <div>
                  <h5 class="text-success">Configuraciones Tienda</h5>
                </div>
                <hr>
                <h5 class="text-success">Stock</h5>
                <div class="text-center">
                  <ProductoTiendaMiniTableComponent :current="current" :filtrartienda="current.lista_precios.codigo" />
                </div>
                <hr>
              </div>
            </div>
            <div class="onboarding-slide">
              <div class="onboarding-content with-gradient">
                <h5 class="onboarding-title text-success">Lista de Precios</h5>
                <br>
                <div class="row">
                  <div class="col-md-12">
                    <table class="table">
                      <thead class="table-primary">
                        <tr>
                          <th class="text-left">Tienda</th>
                          <th class="text-left">Unidad de Medidad</th>
                          <th class="text-center">Precio</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="detalle in precios" v-bind:key="detalle.id">
                          <td class="text-left">
                            {{ current.lista_precios.codigo }}
                          </td>
                          <td class="text-left">
                            {{ detalle.unidad_medida.nombre }}
                          </td>
                          <td class="text-center" style="font-weight: bold;">Q. {{ detalle.precio }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12">
                    <h5 class="onboarding-title text-success">Revisión en Factura</h5>
                    <br>
                    <div class="table-responsive">
                      <table class="table">
                        <thead class="table-primary">
                          <tr>
                            <th class="text-center">Unidad de Medida</th>
                            <th class="text-center">Revisión</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="det in current.productounidadmedida_set" v-bind:key="det.id">
                            <td class="text-left">
                              {{ det.unidad_medida.nombre }}
                            </td>
                            <td class="text-center">
                              <span v-bind:class="{
                                'status-pill green': det.revision_al_despachar == true,
                                'status-pill red': det.revision_al_despachar == false,
                              }"></span>
                            </td>
                            <td>
                              <button title="Activar Revisión de fardos" v-if="det.revision_al_despachar == false"
                                type="button" class="btn btn-sm btn-dark" @click="activarRevision(det)">
                                <i style="font-size: 15px" class="fas fa-exchange-alt"></i>
                              </button>
                              <button title="Desactivar Revisión de fardos" v-if="det.revision_al_despachar == true"
                                type="button" class="btn btn-sm btn-dark" @click="desactivarRevision(det)">
                                <i style="font-size: 15px" class="fas fa-exchange-alt"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import DynamicService from "../../../services/commons/DynamicService";
import ProductoProveedorService from "@/services/catalogos/ProductoProveedorService";
import ProductoTiendaMiniTableComponent from "@/components/cat/precios/ProductoTiendaMiniTableComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    PaginationComponent,
    ProductoTiendaMiniTableComponent,
  },
  data() {
    return {
      filter: {
        producto: "",
      },
      mostrarRefresh: false,
      current: {
        unidad_medida_compra_obj: "",
        unidad_medida_solicitud_obj: "",
        estado: "A",
        unidad_medida: "",
        errors: {},
        unidad_medida: "",
        sku: null,
        unidad_medida_compra: "",
        unidad_medida_solicitud: null,
        productolote_set: "",
        permitir_compra: false,
        consumible: false,
        permitir_venta: false,
        pk: null,
        lista_precios: "",
      },
      precios: {},
      det: {
        proveedor_obj: "",
        id: "",
      },
      detalle: {},
      currentBarras: {},
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
      dataproveedores: [],
      isClicked: false,
    };
  },
  mounted() {
    this.refreshData();
    if (this.$route.params.sku) {
      this.refreshPrecios(this.$route.params.sku);
    }
  },
  methods: {
    updateMultiplicador(det) {
      if (det.permitir_multiplicador == true) {
        det.permitir_multiplicador = false;
      } else {
        det.permitir_multiplicador = true;
      }
      det.id = det.sku;
      DynamicService.save("cat", "productos", det, det).then((response) => { });
    },
    activarRevision(det) {
      DynamicService.save("cat", "producto-unidad_medida", {
        revision_al_despachar: true,
        id: det.id,
        producto: this.current.sku,
        unidad_medida: det.unidad_medida.id,
      }).then((response) => {
        det.revision_al_despachar = true;
      });
    },
    desactivarRevision(det) {
      DynamicService.save("cat", "producto-unidad_medida", {
        revision_al_despachar: false,
        producto: this.current.sku,
        id: det.id,
        unidad_medida: det.unidad_medida.id,
      }).then((response) => {
        det.revision_al_despachar = false;
      });
    },
    copyContent(current) {
      let self = this;
      let str = current.nombre;
      // Realiza la animación al hacer clic
      this.isClicked = true;
      Notifications.toast.success("", "El nombre del producto se copió correctamente");
      // Copia al clipboard
      navigator.clipboard.writeText(str);
    },
    resetAnimation() {
      // Reinicia la animación después de que termine
      this.isClicked = false;
    },
    refreshProveedores(params) {
      let self = this;
      if (params == null) {
        params = {};
      }
      let _params = Object.assign(params, {
        producto: this.current.sku,
        quitar_paginacion: "true",
      });
      ProductoProveedorService.fetch(_params).then((res) => {
        self.dataproveedores = res.data;
      });
    },
    resfreshListaPrecioMyUser() {
      let self = this;
      DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
      })
        .then((response) => {
          this.current.lista_precios = response.data.results;
          if (this.current.lista_precios && this.current.lista_precios[0]) {
            this.current.lista_precios = this.current.lista_precios[0].tienda;
            this.refreshPreciosPorLista();
          } else {
            Notifications.alert.error(
              "Información",
              "El usuario " +
              localStorage.getItem("name") +
              " no esta asignado a ninguna tienda, asignelo antes."
            );
          }
        })
        .catch((error) => {
          Notifications.alert.error(
            "Información",
            "El usuario " +
            localStorage.getItem("name") +
            " no esta asignado a ninguna tienda, asignelo antes."
          );
        });
    },
    refreshPreciosPorLista() {
      let self = this;
      console.log(this.current.lista_precios.lista_precioz);
      DynamicService.fetch("cat", "precios", {
        producto: this.current.sku,
        lista_precio: this.current.lista_precios.lista_precio,
        estatus: true,
      }).then((response) => {
        self.showModal();
        self.precios = response.data.results;
      });
    },
    showModal() {
      let self = this;
      $("#onboardingSlideModal").modal("show");

      $("#onboardingSlideModal.show-on-load").modal("show");
      if ($("#onboardingSlideModal .onboarding-slider-w").length) {
        $("#onboardingSlideModal .onboarding-slider-w").slick({
          dots: true,
          infinite: false,
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow:
            '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style="">Anterior</button>',
          nextArrow:
            '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false">Siguiente</button>',
        });
        $("#onboardingSlideModal").on("shown.bs.modal", function (e) {
          $("#onboardingSlideModal .onboarding-slider-w").slick("setPosition");
        });
        $("#onboardingSlideModal").on("hide.bs.modal", function (e) {
          $("#onboardingSlideModal .onboarding-slider-w").slick("unslick");
        });
      }
    },
    refreshProductoBarra() {
      DynamicService.fetch("cat", "producto-barra", {
        producto: this.current.sku,
      }).then((response) => {
        this.currentBarras = response.data.results;
      });
    },
    refreshPrecios(current) {
      let self = this;
      ProductosService.getById(current).then((response) => {
        self.current = response.data;
        self.refreshProductoBarra();
        self.resfreshListaPrecioMyUser();
        self.refreshProveedores();
      });
    },
    imprimir_barra() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/Barras.jrxml&sku=${self.current.sku}`
      );
    },
    imprimir_hablador() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/HabladorPorTienda.jrxml&tienda=${self.current.lista_precios.codigo}&sku=${self.current.sku}`
      );
    },
    verKardex() {
      let self = this;
      $("#onboardingSlideModal").modal("hide");
      self.$router.push({
        name: "inventario-reportes-kardex",
        params: {
          sku: self.current.sku,
          tienda: self.current.lista_precios.codigo,
        },
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filter_activo,
        sku: this.filter.producto,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.filter.producto = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("cat", "productos", params)
        .then((res) => {
          self.data = res.data;
        })
        .catch((error) => {
          self.data = [];
        });
    },
    hideModal() {
      let self = this;
      $("#onboardingSlideModal").modal("hide");
    },
  },
};
</script>
